import styles from "./colorTheme.module.css"
import { vars } from "./theme"
import { type ColorScheme, isSchemeValue } from "./utils"

const allVariables = Object.values(vars).flatMap((_) => Object.entries(_))

/**
 * Installs theme values that never change but are read via CSS variables.
 */
export function installTheme(element: HTMLElement) {
  allVariables.forEach(([varName, value]) => {
    if (isSchemeValue(value)) return
    element.style.setProperty(`--${varName}`, value)
  })
}

export function uninstallTheme(element: HTMLElement) {
  allVariables.forEach(([varName, value]) => {
    if (isSchemeValue(value)) return
    element.style.setProperty(`--${varName}`, null)
  })
}

/**
 * Installs theme values that change depending on light/dark mode.
 */
export function installColorScheme(element: HTMLElement, scheme: ColorScheme) {
  element.classList.add(styles[`${scheme}Theme`])

  allVariables.forEach(([varName, value]) => {
    if (!isSchemeValue(value)) return
    element.style.setProperty(`--${varName}`, value[scheme])
  })
}

export function uninstallColorScheme(element: HTMLElement) {
  element.classList.remove(styles.darkTheme)
  element.classList.remove(styles.lightTheme)

  allVariables.forEach(([varName, value]) => {
    if (!isSchemeValue(value)) return
    element.style.setProperty(`--${varName}`, null)
  })
}
